






































import orMinus from '@/filters/orMinus';
import { ACTIVE_VAT_RATES } from '@/queries/ClientQueries';
import { GQL_NorwegianVatSymbolEnum } from '@/queries/global';
import { GQL_activeNorwegianVatRates, GQL_activeNorwegianVatRates_allNorwegianVatRates } from '@/queries/__client__/activeNorwegianVatRates';
import { sortBy } from '@/utils/utils';
import groupBy from 'lodash/groupBy';
import { SmartQuery } from 'vue-apollo-decorator';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HistoricVatRates extends Vue {
  @SmartQuery<HistoricVatRates, GQL_activeNorwegianVatRates, { date: string }>({
    query: ACTIVE_VAT_RATES,
    variables() {
      return {
        date: this.$dayjs().format('YYYY-MM-DD'),
      };
    },
    update(data) {
      const grouped = groupBy(data.allNorwegianVatRates, r => r.symbol);

      for (const symbol in grouped) {
        grouped[symbol] = sortBy(grouped[symbol], r => [ [ r.startDate, 'desc' ] ]);
      }

      return grouped;
    },
  }) public vatRates!: Record<GQL_NorwegianVatSymbolEnum, GQL_activeNorwegianVatRates_allNorwegianVatRates[]>;

  private orMinus = orMinus;
}
